var render = function render(){var _vm=this,_c=_vm._self._c;return _c('p',{staticClass:"form-message",class:{'is-success': _vm.success, 'is-error': _vm.error}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }